import { useEffect, useRef, useState } from 'react';

// 1px tolerance for sub-pixel widths
export const hasMoreToTheRight = ({
  scrollLeft,
  clientWidth,
  scrollWidth,
}: Pick<HTMLElement, 'scrollLeft' | 'clientWidth' | 'scrollWidth'>) =>
  scrollLeft + clientWidth < scrollWidth - 1;

// Whether a sideways-scrolling box has hidden content on its right, for an edge fade.
// Pass contentKey (e.g. a row count) to re-check when the content changes.
export function useHorizontalScrollFade<T extends HTMLElement>(
  contentKey?: unknown
) {
  const ref = useRef<T>(null);
  const [showFade, setShowFade] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setShowFade(hasMoreToTheRight(el));
    update();
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      el.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [contentKey]);

  return { ref, showFade };
}
